// TODO Handle temp textbox serialization (serialize it to null)

fabric.TextLabel = fabric.util.createClass(fabric.Textbox, {
  type: "textLabel",

  initialize: function (text, options) {
    options || (options = {});

    options = {
      ...options,
      ...textLabelDefaults,
    };

    this.callSuper("initialize", text, options);
  },

  toObject: function () {
    const o = this.callSuper("toObject");

    return {
      id: this.id,
      type: "textLabel",
      left: o.left,
      top: o.top,
      width: o.width,
      height: o.height,
      scaleX: o.scaleX,
      scaleY: o.scaleY,
      angle: o.angle,
      text: o.text,
    };
  },

  _render: function (ctx) {
    this.callSuper("_render", ctx);
  },
});

fabric.TextLabel.fromObject = function (object, callback) {
  return fabric.Object._fromObject("TextLabel", object, callback, "text");
};

const textLabelDefaults = {
  version: "5.2.1",
  originX: "left",
  originY: "top",
  // "left": 92,
  // "top": 146,
  // "width": 600,
  // "height": 81.36,
  fill: "#080808",
  stroke: null,
  strokeWidth: 1,
  strokeDashArray: null,
  strokeLineCap: "butt",
  strokeDashOffset: 0,
  strokeLineJoin: "miter",
  strokeUniform: false,
  strokeMiterLimit: 4,
  // "scaleX": 1,
  // "scaleY": 1,
  // "angle": -0.29,
  flipX: false,
  flipY: false,
  opacity: 1,
  shadow: null,
  visible: true,
  backgroundColor: "transparent",
  fillRule: "nonzero",
  paintFirst: "fill",
  globalCompositeOperation: "source-over",
  skewX: 0,
  skewY: 0,
  fontFamily: "Neucha",
  // fontWeight: "bold",
  fontSize: 48,
  // "text": "Hello World!",
  underline: false,
  overline: false,
  linethrough: false,
  textAlign: "left",
  fontStyle: "normal",
  lineHeight: 1.16,
  textBackgroundColor: "",
  charSpacing: 0,
  styles: {},
  direction: "ltr",
  path: null,
  pathStartOffset: 0,
  pathSide: "left",
  pathAlign: "baseline",
  minWidth: 20,
  splitByGrapheme: false,
};

fabric.TextNote = fabric.util.createClass(fabric.Textbox, {
  type: "textNote",

  initialize: function (text, options) {
    options || (options = {});

    options = {
      ...options,
      ...textNoteDefaults,
    };

    this.callSuper("initialize", text, options);
  },

  toObject: function () {
    const o = this.callSuper("toObject");

    return {
      id: this.id,
      type: "textNote",
      left: o.left,
      top: o.top,
      width: o.width,
      height: o.height,
      scaleX: o.scaleX,
      scaleY: o.scaleY,
      angle: o.angle,
      text: o.text,
    };
  },

  _render: function (ctx) {
    this.callSuper("_render", ctx);
  },
});

fabric.TextNote.fromObject = function (object, callback) {
  return fabric.Object._fromObject("TextNote", object, callback, "text");
};

const textNoteDefaults = {
  version: "5.2.1",
  originX: "left",
  originY: "top",
  // "left": 92,
  // "top": 146,
  // "width": 600,
  // "height": 81.36,
  fill: "#555",
  stroke: null,
  strokeWidth: 1,
  strokeDashArray: null,
  strokeLineCap: "butt",
  strokeDashOffset: 0,
  strokeLineJoin: "miter",
  strokeUniform: false,
  strokeMiterLimit: 4,
  // "scaleX": 1,
  // "scaleY": 1,
  // "angle": -0.29,
  flipX: false,
  flipY: false,
  opacity: 1,
  shadow: null,
  visible: true,
  backgroundColor: "transparent",
  fillRule: "nonzero",
  paintFirst: "fill",
  globalCompositeOperation: "source-over",
  skewX: 0,
  skewY: 0,
  fontFamily: "Neucha",
  // fontWeight: "regular",
  fontSize: 32,
  underline: false,
  overline: false,
  linethrough: false,
  textAlign: "left",
  fontStyle: "normal",
  lineHeight: 1.16,
  textBackgroundColor: "",
  charSpacing: 0,
  styles: {},
  direction: "ltr",
  path: null,
  pathStartOffset: 0,
  pathSide: "left",
  pathAlign: "baseline",
  minWidth: 20,
  splitByGrapheme: false,
};

fabric.Sticky = fabric.util.createClass(fabric.Group, {
  type: "sticky",

  initialize: function (items, options) {
    options || (options = {});

    delete options.objects;

    options = {
      ...options,
      ...stickyDefaults,
    };

    this.callSuper("initialize", items, options);
  },

  toObject: function () {
    const o = this.callSuper("toObject");

    return {
      type: "sticky",
      id: this.id,
      left: o.left,
      top: o.top,
      width: o.width,
      height: o.height,
      scaleX: o.scaleX,
      scaleY: o.scaleY,
      angle: o.angle,
      objects: o.objects,
    };
  },

  _render: function (ctx) {
    this.callSuper("_render", ctx);
  },
});

fabric.Sticky.fromObject = function (object, callback) {
  var objects = object.objects,
    options = fabric.util.object.clone(object, true);

  delete options.objects;

  fabric.util.enlivenObjects(objects, function (enlivenedObjects) {
    var options = fabric.util.object.clone(object, true);
    delete options.objects;
    fabric.util.enlivenObjectEnlivables(object, options, function () {
      callback && callback(new fabric.Sticky(enlivenedObjects, options, true));
    });
  });
};

const stickyDefaults = {
  lockScalingX: true,
  lockScalingY: true,
  version: "5.2.1",
  originX: "left",
  originY: "top",
  // "left": 87,
  // "top": 276,
  // "width": 202,
  // "height": 202,
  fill: "rgb(0,0,0)",
  stroke: null,
  strokeWidth: 0,
  strokeDashArray: null,
  strokeLineCap: "butt",
  strokeDashOffset: 0,
  strokeLineJoin: "miter",
  strokeUniform: false,
  strokeMiterLimit: 4,
  // "scaleX": 1,
  // "scaleY": 1,
  // "angle": 0.08,
  flipX: false,
  flipY: false,
  opacity: 1,
  shadow: null,
  visible: true,
  backgroundColor: "",
  fillRule: "nonzero",
  paintFirst: "fill",
  globalCompositeOperation: "source-over",
  skewX: 0,
  skewY: 0,
};

fabric.StickyRect = fabric.util.createClass(fabric.Rect, {
  type: "stickyRect",

  initialize: function (options) {
    options || (options = {});

    options = {
      ...options,
      ...stickyRectDefaults,
    };

    this.callSuper("initialize", options);
  },

  toObject: function () {
    const o = this.callSuper("toObject");

    return {
      parent: this.parent,
      type: "stickyRect",
      scaleX: o.scaleX,
      scaleY: o.scaleY,
      angle: o.angle,
      fill: o.fill,
      width: o.width, // TODO - Subclass L sticky
    };
  },

  _render: function (ctx) {
    this.callSuper("_render", ctx);
  },
});

fabric.StickyRect.fromObject = function (object, callback) {
  return fabric.Object._fromObject("StickyRect", object, callback);
};

const stickyRectDefaults = {
  lockScalingX: true,
  lockScalingY: true,
  version: "5.2.1",
  originX: "center",
  originY: "center",
  left: 0,
  top: 0,
  // "width": 200,
  height: 200,
  // "fill": "#fff740",
  stroke: "#0b0b0b20",
  strokeWidth: 2,
  strokeDashArray: null,
  strokeLineCap: "butt",
  strokeDashOffset: 0,
  strokeLineJoin: "miter",
  strokeUniform: false,
  strokeMiterLimit: 4,
  // "scaleX": 1,
  // "scaleY": 1,
  // "angle": 0,
  flipX: false,
  flipY: false,
  opacity: 1,
  shadow: {
    color: "#00000060",
    blur: 5,
    offsetX: 2,
    offsetY: 2,
    affectStroke: false,
    nonScaling: false,
  },
  visible: true,
  backgroundColor: "",
  fillRule: "nonzero",
  paintFirst: "fill",
  globalCompositeOperation: "source-over",
  skewX: 0,
  skewY: 0,
  rx: 0,
  ry: 0,
};

fabric.StickyLabel = fabric.util.createClass(fabric.Textbox, {
  type: "stickyLabel",

  initialize: function (text, options) {
    options || (options = {});

    options = {
      ...options,
      ...stickyTextboxDefaults,
    };

    this.callSuper("initialize", text, options);
  },

  toObject: function () {
    const o = this.callSuper("toObject");

    return {
      type: "stickyLabel",
      parent: this.parent,
      scaleX: o.scaleX,
      scaleY: o.scaleY,
      angle: o.angle,
      text: o.text,
      width: o.width,
    };
  },

  _render: function (ctx) {
    this.callSuper("_render", ctx);
  },
});

fabric.StickyLabel.fromObject = function (object, callback) {
  return fabric.Object._fromObject("StickyLabel", object, callback, "text");
};

fabric.StickyEditLabel = fabric.util.createClass(fabric.Textbox, {
  type: "stickyEditLabel",

  initialize: function (text, options) {
    options || (options = {});

    // options = {
    //   ...options,
    //   ...stickyTextboxDefaults,
    // };

    this.callSuper("initialize", text, options);
  },

  toObject: function () {
    return null;
  },

  _render: function (ctx) {
    this.callSuper("_render", ctx);
  },
});

fabric.StickyEditLabel.fromObject = function (object, callback) {
  return fabric.Object._fromObject("StickyEditLabel", object, callback, "text");
};

const stickyTextboxDefaults = {
  version: "5.2.1",
  originX: "center",
  originY: "center",
  left: 0,
  top: 0,
  height: 33.9,
  fill: "#080808",
  stroke: null,
  strokeWidth: 1,
  strokeDashArray: null,
  strokeLineCap: "butt",
  strokeDashOffset: 0,
  strokeLineJoin: "miter",
  strokeUniform: false,
  strokeMiterLimit: 4,
  // "scaleX": 1,
  // "scaleY": 1,
  // "angle": 0,
  flipX: false,
  flipY: false,
  opacity: 1,
  shadow: null,
  visible: true,
  backgroundColor: "transparent",
  fillRule: "nonzero",
  paintFirst: "fill",
  globalCompositeOperation: "source-over",
  skewX: 0,
  skewY: 0,
  fontFamily: "Neucha",
  fontWeight: "normal",
  fontSize: 30,
  // "text": "",
  underline: false,
  overline: false,
  linethrough: false,
  textAlign: "center",
  fontStyle: "normal",
  lineHeight: 1.16,
  textBackgroundColor: "",
  charSpacing: 0,
  styles: {},
  direction: "ltr",
  path: null,
  pathStartOffset: 0,
  pathSide: "left",
  pathAlign: "baseline",
  minWidth: 20,
  // splitByGrapheme: true,
};
